import { useState, useEffect, useContext } from "react";
import ManagementSidebar from "../components/superAdminPanel/ManagementSidebar/ManagementSidebar.js";
import ManagementContent from "../components/superAdminPanel/ManagementSidebar/ManagementContent.jsx";
import AuthenticationContext from "../context/Authentication/AuthenticationContext.tsx";

export default function SuperAdminPanel() {
  const [requestId, setRequestId] = useState([0]);
  const auth = useContext(AuthenticationContext);
  const [accessLevel, setAccessLevel] = useState([]);
  useEffect(() => {
    let temp = [];
    for (let i = 0; i < auth.userInfo.access_level.codes.length; i++) {
      temp.push(auth.userInfo.access_level.codes[i]);
    }
    console.log("temp", temp);
    setAccessLevel(temp);
  }, []);
  const requestIdHandler = id => {
    let temp = [...requestId];
    // !requestId.includes(id) && (temp = [...temp, id]);
    !requestId.includes(id) && (temp = [id]);
    setRequestId(temp);
    console.log("requestId", requestId);
  };
  return (
    <div className="d-flex h-100">
      <ManagementSidebar
        requestIdHandler={requestIdHandler}
        accessLevel={accessLevel}
      />
      <ManagementContent accessLevel={accessLevel} requestId={requestId} />
    </div>
  );
}
